export default {
  FAQ: "/docs/NotorosFAQ.pdf",
  WHITEPAPER: "/docs/Notoros_Whitepaper_V1.pdf",
  WEBSITE_ACCEPTABLE_USE: "/docs/NotorosIoAcceptableUsePolicy.pdf",
  WEBSITE_PRIVACY_POLICY: "/docs/NotorosIoPrivacyPolicy.pdf",
  NOTOROS_UI_GUIDE: "/docs/gettingStarted.pdf"
}